var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routePath === '/guidePage' || _vm.routePath === '/newsMore' ? false : true )?_c('div',{staticClass:"collapse"},[_c('i',{staticClass:"coll-fold",class:_vm.collapse ? 'el-icon-s-fold' : 'el-icon-menu',on:{"click":_vm.toggleCollapse}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }